"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvocationSource = void 0;
/**
 * Represents the source of speech recognition invocation.
 */
var InvocationSource;
(function (InvocationSource) {
    /**
     * No invocation source specified.
     */
    InvocationSource["None"] = "None";
    /**
     * Voice activation with a keyword.
     */
    InvocationSource["VoiceActivationWithKeyword"] = "VoiceActivationWithKeyword";
})(InvocationSource = exports.InvocationSource || (exports.InvocationSource = {}));

//# sourceMappingURL=InvocationSource.js.map
